import { OptionsControl } from './options.model';
import { BaseControl } from '@app/shared/dynamic-form/shared/controls/base-control';
import { ColumnsTableModalSelect } from './../../../models/modal-select.model';

interface OptionsModalSelect extends Partial<OptionsControl<any>> {
  tmpParameter?: any;
  data: Array<any>;
  columns: Array<ColumnsTableModalSelect>;
  classModal: string;
  keyValue: string;
  actionAdd: boolean;
  actionUpdate: boolean;
  actionDelete: boolean;
  automaticRequest?: boolean;
  loadData?: (...arg: any[]) => any[];
}

export class ModalSelect extends BaseControl<any> implements OptionsModalSelect {
  controlType = 'modalSelect';
  tmpParameter: any;
  data: Array<any>;
  columns: Array<ColumnsTableModalSelect>;
  classModal: string;
  actions: boolean;
  keyValue: string;
  actionAdd: boolean;
  actionUpdate: boolean;
  actionDelete: boolean;
  automaticRequest: boolean;
  loadData: (...arg: any[]) => any[];

  constructor(options: OptionsModalSelect) {
    super(options);
    this.tmpParameter = options.tmpParameter;
    this.data = options.data;
    this.columns = options.columns;
    this.classModal = options.classModal;
    this.keyValue = options.keyValue;
    this.actionAdd = options.actionAdd;
    this.actionUpdate = options.actionUpdate;
    this.actionDelete = options.actionDelete;
    this.automaticRequest = options.automaticRequest || false;
    this.loadData = options.loadData;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/modal-select.ts